<template>
  <div>
    <h3>Workload Revision</h3>
    <workload-form v-if="callsCompleted"></workload-form>
    <div class="text-right mt-2">
      <b-button variant="primary" @click="submitWorkload()">Submit</b-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import WorkloadForm from "../../components/workloads/workload-form";
import ToastrSettings from "../../settings/toastr-settings";
import toastr from "toastr";

export default {
  data() {
    return {
      employeeJobsInitialized: false,
      workloadTypeDefinitionsInitialized: false
    };
  },

  props: {
    workloadId: {
      required: true
    }
  },

  components: {
    "workload-form": WorkloadForm
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    callsCompleted: function() {
      return (
        this.employeeJobsInitialized && this.workloadTypeDefinitionsInitialized
      );
    }
  },

  watch: {
    callsCompleted: function() {
      if (this.callsCompleted) {
        this.initializeFromId(this.workloadId);
      }
    }
  },

  methods: {
    ...mapActions("workloadForm", [
      "getWorkloadTypeDefinitions",
      "initializeFromId",
      "initializeWorkloadTypes",
      "addWorkload",
      "sendRevisionEmail",
      "getEmployeeJobs",
      "sendWorkloadSubmittedEmail"
    ]),

    submitWorkload: function() {
      var that = this;

      this.addWorkload().then(function(response) {
        // Toastr Message
        toastr.options = ToastrSettings;
        toastr.success("Workload revision submitted.", "Success");

        that.sendWorkloadSubmittedEmail(response.data.workloadId);

        if (
          response.data.workloadStatuses[0].workloadStatusDefinition.name ===
          "Revision"
        ) {
          // send email about revision
          that
            .sendRevisionEmail(response.data.workloadId)
            .then(function() {
              // redirect
              that.$router.push({ name: "dashboard" });
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          // redirect
          that.$router.push({ name: "dashboard" });
        }
      });
    }
  },

  created() {
    var that = this;

    this.getWorkloadTypeDefinitions()
      .then(function() {
        that
          .initializeWorkloadTypes()
          .then(function() {
            that.workloadTypeDefinitionsInitialized = true;
          })
          .catch(function(error) {
            console.log(error);
          });
      })
      .catch(function(error) {
        console.log(error);
      });

    this.getEmployeeJobs(this.user.userId)
      .then(function() {
        that.employeeJobsInitialized = true;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
</style>
